import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { CommonService } from "src/app/common.service";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import * as moment from "moment";
import { MustBeAfter } from "../utils/must-be-after.validator";
import { InlineResponse200 } from "profile-api";
import {
  Announcement,
  AnnouncementOffer,
  Base64Document,
} from "announcement-api";
import { ModalComponent } from "../modal/modal.component";
import {
  GetAnnouncementOfferStatusDescription
} from "../utils/announcement-offer-utils";
import {
  GetAnnouncementStatusDescription,
  GetAnnouncementTypeDescription
} from "../utils/announcement-utils";
import { Router } from "@angular/router";
import { InvalidControlScrollDirective } from "../ng-invalid-control-scroll-wt-directive.directive";
import { ConfigurationVariablesList } from "std-api";

@Component({
  selector: "app-announcement-detail",
  templateUrl: "./announcement-detail.component.html",
  styleUrls: ["./announcement-detail.component.css"],
})
export class AnnouncementDetailComponent implements OnInit {


  @Input("announcementId") announcementId: number;

  @ViewChild("confirmationModal") confirmationModal: ModalComponent;
  @ViewChild("refusalModal") refusalModal: ModalComponent;
  @ViewChild("uploadInput") uploadInput: ElementRef;

  locale: string = "it";

  form: FormGroup;
  announcement: Announcement;
  selectedOffer: AnnouncementOffer;
  provinceCodes = new Array();
  provinceList = null;
  categoryList = null;
  announcementTypeList = [];
  loading = false;
  error = "no_error";
  detailListError = "no_error";
  categoryError: string = "no_error";
  endDateError: string = "no_error";
  unitOfMeasureError: string = "no_error";
  contactError: string = "no_error";
  announcementTypeError: string = "no_error";
  saveMessage: string = "L'annuncio è stato salvato correttamente.";
  showSaveMessage: boolean = false;
  startDateAlert: string = "";
  endDateAlert: string = "";
  announcementStatusDescr: string;
  //  publishedParticipations: Array<SelectableParticipation>;
  confirmationModalMsg: string;
  confirmationModalSubmitMsg: string;
  unitOfMeasureList = null;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private invalidControlScrollDirective: InvalidControlScrollDirective
  ) { }

  ngOnInit(): void {
    console.log("Announcement id = " + this.announcementId);

    window["moment"] = moment;

    this.form = this.formBuilder.group(
      {
        title: new FormControl("", [Validators.required]),
        unitPrice: new FormControl([Validators.required]),
        amount: new FormControl([Validators.required]),
        categoryCode: new FormControl([Validators.required]),
        announcementType: new FormControl([Validators.required]),
        unitOfMeasureCode: new FormControl([Validators.required]),
        contactName: new FormControl([Validators.required]),
        contactPhone: new FormControl([Validators.required]),
        contactEmail: new FormControl("", [
          Validators.pattern(CommonService.EMAIL_REGEXP),
        ]),
        description: new FormControl("", [Validators.required]),
        startDate: new FormControl("", [Validators.required]),
        endDate: new FormControl("", [Validators.required]),
      },
      {
        validator: MustBeAfter("startDate", "endDate"),
      }
      
    );

    this.announcementTypeList.push("SALE");
    this.announcementTypeList.push("RENTAL");

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("ANNOUNCEMENT_CATEGORY")
      .subscribe(
        (data) => {
          this.categoryList = data.items;
          console.log(
            "categoryList: " +
            JSON.stringify(this.categoryList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle categorie.";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("UNIT_OF_MEASURE")
      .subscribe(
        (data) => {
          this.unitOfMeasureList = data.items;
          console.log(
            "unitOfMeasureList: " +
            JSON.stringify(this.unitOfMeasureList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle unitOfMeasureList.";
          console.log(error);
        }
      );


    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("UNIT_OF_MEASURE")
      .subscribe(
        (data) => {
          this.unitOfMeasureList = data.items;
          console.log(
            "Unit of measure: " + JSON.stringify(this.unitOfMeasureList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle unità di misura.";
          console.log(error);
        }
      );

    let startDateControl = this.form.get("startDate");
    startDateControl.valueChanges.subscribe((date) => {
      if (startDateControl.invalid) {
        this.startDateAlert = "ng-date-container-alert";
      } else {
        this.startDateAlert = "";
        this.resetError();
      }
    });

    let endDateControl = this.form.get("endDate");
    endDateControl.valueChanges.subscribe((date) => {
      setTimeout(() => {
        if (endDateControl.invalid) {
          this.endDateAlert = "ng-date-container-alert";
        } else {
          this.endDateAlert = "";
          this.resetError();
        }
      });
    });

    this.loadData();

  }

  loadData() {
    this.commonService
      .getProvinces()
      .then((provinceList: InlineResponse200) => {
        this.provinceList = provinceList;
      })
      .catch((error) => {
        this.error = "Impossibile caricare la lista delle province.";
        console.log(error);
      });
    if (this.announcementId) {
      this.commonService
        .getAnnouncementsService()
        .announcementAnnouncementIdGet(this.announcementId)
        .subscribe(
          (announcement) => {
            console.log("loaded announcement");
            console.log(announcement);
            this.announcement = announcement;
            this.loadAnnouncementInForm(announcement);
            this.loadProvinces(announcement);
          },
          (error) => {
            console.log(
              "Impossibile caricare l'annuncio' " +
              this.announcementId +
              "; error: " +
              error
            );
          }
        );
    } else {
      this.announcement = {
        announcementStatus: "DRAFT",
        announcementType: "SALE",
        contactEmail: "",
        contactPhone: "",
        contactName: "",
        title: "",
        description: "",
        attachments: [],
      };

      this.loadAnnouncementInForm(this.announcement);
    }
  }

  resetError() {
    this.error = "no_error";
  }

  getAnnouncement() {
    let formValues = this.form.getRawValue();
    console.log("ID: " + this.announcement.announcementId);
    delete formValues.startDate;
    delete formValues.endDate;
    let startDate = moment(this.form.get("startDate").value);
    let endDate = moment(this.form.get("endDate").value);
    let announcement: Announcement =
    {
      ...formValues,
      announcementId: this.announcement.announcementId,
      attachments: this.announcement.attachments,
      provinces: this.provinceCodes.map(province => province.code),
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    };
    return announcement;
  }

  scrollToComponent(componentId) {
    let invalidElement: HTMLElement = document.getElementById(componentId);
    this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
      invalidElement
    );
  }

  validateSaveData(submitRequired: boolean) {
    this.resetValidators();

    if (!this.form.get("announcementType").value) {
      this.announcementTypeError = "Selezionare il tipo di annuncio.";
      this.scrollToComponent("announcementTypeComp");
      return false;
    } else {
      this.announcementTypeError = "no_error";
    }

    if (!this.form.get("categoryCode").value) {
      this.categoryError = "Selezionare una categoria.";
      this.scrollToComponent("category");
      return false;
    } else {
      this.categoryError = "no_error";
    }

    if (this.form.get("startDate").invalid) {
      this.startDateAlert = "ng-date-container-alert";
    } else {
      this.startDateAlert = "";
    }

    if (this.form.get("endDate").invalid) {
      this.endDateError = "Scegliere una data di fine posteriore a quella di inizio.";
    } else {
      this.endDateError = "no_error";
    }
    let startDate = moment(this.form.get("startDate").value)
    let endDate = moment(this.form.get("endDate").value)
    
    if (startDate > endDate) {
      this.endDateError = "Scegliere una data di fine posteriore a quella di inizio";
      this.scrollToComponent("endDate");
      return false;
    } else {
      this.endDateError = "no_error";
    }

    if (!this.form.valid) {
      const controls = this.form.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          let invalidElement: HTMLElement = document.getElementById(name);
          this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
            invalidElement
          );
          break;
        }
      }
      return false;
    }
    if (submitRequired) {
      if (!this.form.get("amount").value) {
        this.unitOfMeasureError = "Selezionare la quantità.";
        this.scrollToComponent("unitOfMeasureComp");
        return false;
      } else {
        this.unitOfMeasureError = "no_error";
      }

      if (!this.form.get("unitOfMeasureCode").value) {
        this.unitOfMeasureError = "Selezionare una unità di misura.";
        this.scrollToComponent("unitOfMeasureComp");
        return false;
      } else {
        this.unitOfMeasureError = "no_error";
      }

      if (!this.form.get("unitPrice").value) {
        this.unitOfMeasureError = "Selezionare l'importo unitario.";
        this.scrollToComponent("unitOfMeasureComp");
        return false;
      } else {
        this.unitOfMeasureError = "no_error";
      }

      if (!this.form.get("contactName").value) {
        this.contactError = "Indicare il nome del contatto.";
        this.scrollToComponent("contactName");
        return false;
      } else {
        this.contactError = "no_error";
      }

      if (!this.form.get("contactEmail").value) {
        this.contactError = "Indicare l'email del contatto.";
        this.scrollToComponent("contactEmail");
        return false;
      } else {
        this.contactError = "no_error";
      }

      if (!this.form.get("contactPhone").value) {
        this.contactError = "Indicare il telefono del contatto.";
        this.scrollToComponent("contactPhone");
        return false;
      } else {
        this.contactError = "no_error";
      }


    }
    return true;
  }

  submitAnnouncement() {
    this.loading = true;
    if (!this.validateSaveData(true)) {
      this.error = "I campi non sono compilati correttamente.";
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }

    this.loading = true;
    if (!this.validateSaveData(false)) {
      this.error = "I campi non sono compilati correttamente.";
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }

    let announcement: Announcement = this.getAnnouncement();
    console.log("Publishing Announcement: " + JSON.stringify(announcement));
    this.commonService
      .getAnnouncementWorflowService()
      .announcementAnnouncementIdSubmitPut(announcement.announcementId, announcement)
      .subscribe(
        (announcement: Announcement) => {
          this.announcement = announcement;
          this.loadAnnouncementInForm(announcement);
          this.loading = false;

          this.saveMessage = "L'annuncio è stato salvato correttamente.";
          this.showSaveMessage = true;
          this.detailListError = "no_error";

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante la pubblicazione della gara.";
          }
          this.loading = false;
          console.log(error);
        }
      );

  }

  saveAnnouncement() {
    this.loading = true;
    if (!this.validateSaveData(false)) {
      this.error = "I campi non sono compilati correttamente.";
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }

    let announcement: Announcement = this.getAnnouncement();
    console.log("Sending Announcement: " + JSON.stringify(announcement));
    if (announcement.announcementId) {
      this.commonService
        .getAnnouncementsService()
        .announcementAnnouncementIdPut(announcement.announcementId, announcement)
        .subscribe(
          (announcement: Announcement) => {
            this.announcement = announcement;
            this.loadAnnouncementInForm(announcement);
            this.loading = false;

            this.saveMessage = "L'annuncio è stato salvato correttamente.";
            this.showSaveMessage = true;
            this.detailListError = "no_error";

            var that = this;
            setTimeout(function () {
              that.showSaveMessage = false;
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della gara.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    } else {
      this.commonService
        .getAnnouncementsService()
        .announcementPost(announcement)
        .subscribe(
          (announcement: Announcement) => {
            this.announcement = announcement;
            this.loadAnnouncementInForm(announcement);
            this.loading = false;

            this.saveMessage = "L'annuncio è stato salvato correttamente.";
            this.showSaveMessage = true;
            this.detailListError = "no_error";

            var that = this;
            setTimeout(function () {
              that.showSaveMessage = false;
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della gara.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    }
  }

  resetValidators() {
    const controls = this.form.controls;
    this.form.updateValueAndValidity();
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].updateValueAndValidity()
    );
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].markAsDirty()
    );
  }

  confirmationModalSubmit() {

  }

  applicationsModalSubmit() {

  }

  goToAnnouncements() {
    this.router.navigate(["/areariservata"], {
      queryParams: { tabToLoad: "announcements" },
    });
  }

  getAnnouncementStatusDescr() {
    return GetAnnouncementStatusDescription(this.announcement.announcementStatus);
  }

  getAnnouncementOfferStatusDescr(offer: AnnouncementOffer) {
    return GetAnnouncementOfferStatusDescription(offer.announcementOfferStatus);
  }

  getAnnouncementTypeDescr(announcementType: string) {
    return GetAnnouncementTypeDescription(announcementType);
  }

  loadAnnouncementInForm(ann: Announcement) {
    this.form.reset(ann);
    this.form.patchValue({
      startDate: moment(this.announcement.startDate).toDate(),
    });
    this.form.patchValue({
      endDate: moment(this.announcement.endDate).toDate(),
    });
  }

  addProvince() {
    this.provinceCodes.push({ code: null });
  }

  removeProvince(provinceCode: string) {
    console.log("Removing province: " + provinceCode)
    console.log("current provinces: " + JSON.stringify(this.provinceCodes));
    this.provinceCodes = this.provinceCodes.filter(
      (item) => item.code !== provinceCode
    );
  }

  loadProvinces(announcement: Announcement) {
    for (let i = 0; i < announcement.provinces.length; ++i) {
      this.provinceCodes.push({ code: announcement.provinces[i] });
    }
  }

  deleteAttachment(attachment: Base64Document) {
    this.announcement.attachments = this.announcement.attachments.filter((obj) => obj !== attachment);
  }

  openAttachment(attachment: Base64Document, event: any) {
    if (attachment.documentUrl) {
      window.open(attachment.documentUrl);
      if (event !== null && event !== undefined) {
        event.stopPropagation();
      }
    } else {
      console.log("No document URL");
    }
  }

  uploadAttachment(event: { target: { files: any[] } }) {
    let files = event.target.files;
    let file = files[0];
    if (files && file) {
      const reader = new FileReader();
      let attachment: Base64Document = {};
      attachment.fileName = file.name;
      attachment.mimeType = file.type;
      reader.onload = (readerEvt: { target: { result: any } }) => {
        return this.handleReaderLoaded(attachment, readerEvt);
      };
      reader.readAsBinaryString(file);
      this.announcement.attachments.push(attachment);
    }
  }

  handleReaderLoaded(
    attachment: Base64Document,
    readerEvt: { target: { result: any } }
  ) {
    let binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    attachment.base64Content = base64textString;
  }

  uploadInputClick() {
    this.uploadInput.nativeElement.click();
  }

  acceptOffer(offer: AnnouncementOffer) {
    console.log("Accepting offer " + JSON.stringify(offer));
    this.commonService
      .getAnnouncementOfferWorkflowService()
      .announcementOfferAnnouncementOfferIdAcceptPut(offer.announcementOfferId, offer)
      .subscribe(
        (data) => {
          this.loadData()
        },
        (error) => {
          this.error = "Impossibile accettare l'offerta";
          console.log(error);
        }
      );
  }

  refuseOffer(offer: AnnouncementOffer) {
    this.selectedOffer = offer;
    this.refusalModal.open();
    console.log("selected offer " + JSON.stringify(this.selectedOffer));
  }

  refuseOfferWithNotes() {
    console.log("Refusing offer " + JSON.stringify(this.selectedOffer));
    this.commonService
    .getAnnouncementOfferWorkflowService()
    .announcementOfferAnnouncementOfferIdRefusePut(this.selectedOffer.announcementOfferId, this.selectedOffer)
    .subscribe(
      (data) => {
        this.loadData()
      },
      (error) => {
        this.error = "Impossibile rifiutare l'offerta";
        console.log(error);
      }
    );
  }
}
